import React from "react";

const ModalSpinner = ({ width, height, color }) => {
  return (
    <svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M-3.71547e-06 0.499998C5.58118 0.499998 11.1077 1.59929 16.264 3.73512C21.4204 5.87095 26.1055 9.00147 30.052 12.948C33.9985 16.8945 37.1291 21.5796 39.2649 26.736C41.4007 31.8923 42.5 37.4188 42.5 43L27.625 43C27.625 39.3722 26.9105 35.78 25.5222 32.4284C24.1339 29.0767 22.099 26.0314 19.5338 23.4662C16.9686 20.901 13.9232 18.8661 10.5716 17.4778C7.22001 16.0895 3.62776 15.375 -3.06526e-06 15.375L-3.71547e-06 0.499998Z"
        fill="url(#paint0_angular_2787_845)"
      />
      <defs>
        <radialGradient
          id="paint0_angular_2787_845"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(-1.85773e-06 43) rotate(-90) scale(42.5)"
        >
          <stop offset="0.9999" stop-color="#FF4400" />
          <stop offset="1" stop-color="#00AFAA" stop-opacity="0.01" />
        </radialGradient>
      </defs>
    </svg>
  );
};


export default ModalSpinner